import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import "./PhoneNumber.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import {
  createPhoneNumber,
  updatePhoneNumber,
  deletePhoneNumber,
} from "../../services/ContactList";
import { getPhoneNumber } from "../../services/Campaign";

// import './ContactList.css'
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Loader from "../Loader";
import { useAuth } from "../../context/AuthContext";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
// delete
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ECE0FF",
    color: "#747474",
    // maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: "15px",
    boxShadow: "0px 0px 11px 0px rgba(128, 139, 157, 0.15)",
  },
}));

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));
// Voice1
const ITEM_HEIGHTVoice1 = 40;
const ITEM_PADDING_TOPVoice1 = 8;
const MenuPropsVoice1 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice1 * 4.5 + ITEM_PADDING_TOPVoice1,
    },
  },
};

const drawerWidth = 300;
const PhoneNumber = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const navigate = useNavigate();

  // password-start
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [authToken, setAuthToken] = React.useState(false);
  const handleClickToken = () => setAuthToken((show) => !show);
  // password-end

  // Voice1
  const themeVoice1 = useTheme();
  const [personNameVoice1, setPersonNameVoice1] = React.useState([]);
  const handleChangeVoice1 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice1(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [phoneDetails, setPhoneDetails] = useState({
    name: "",
    type: "twilio",
    phoneNumber: "",
    authToken: "",
    sID: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    type: "",
    phoneNumber: "",
    authToken: "",
    sID: "",
  });

  // TablePagination-start

  const [editOpen, setEditOpen] = useState(false);

  // TablePagination-start
  const [page, setPage] = useState(0); // Page state (0-based index)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page state
  const [totalPages, setTotalPages] = useState(0); // Total pages from backend

  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update current page
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value); // Update rows per page
    setPage(0); // Reset to page 0 when rows per page change
  };

  const [load, setLoad] = useState(false);

  const { userResponse } = useAuth();

  const [phoneNumberList, setPhoneNumberList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log("checksavailabl");
    // if(userResponse.haveNumber===true){
    getAllPhoneNumber();

    // }
  }, []);

  const getAllPhoneNumber = async () => {
    setIsLoading(true);
    const response = await getPhoneNumber();
    if (response?.data?.success === true) {
      setPhoneNumberList(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleEditPopOpen = async (data) => {
    setPop(true);
    console.log("Data", data);
    setPhoneDetails({
      name: data?.name,
      type: "twilio",
      phoneNumber: data?.phoneNumber,
      authToken: data?.authToken,
      sID: data?.sid,
      numberId: data?.numberId,
    });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue?.trim();
    const fieldId = e?.target?.id;

    let isValid = true;
    let errorMessage = {};

    // Handle email validation
    if (fieldName === "phoneNumber") {
      if (value === "" || value === undefined) {
        // errorMessage.phoneNumber = "Phone Number is required";
        // isValid = false;
      } else if (/^\d{0,9}$/.test(value)) {
        e.preventDefault();
        errorMessage.phoneNumber = "Only allow 10 numbers";
        isValid = false;
      }
    }
    if (fieldName === "name" && (value === "" || value === undefined)) {
      // errorMessage.name = "Name is required";
      // isValid = false;
    }
    if (fieldName === "sID") {
      if (value === "" || value === undefined) {
        // errorMessage.sID = "Account SID is required";
        // isValid = false;
      }
    }
    if (fieldName === "authToken") {
      // errorMessage.authToken = "Auth Token is required";
      // isValid = false;
    }
    if (fieldId === "dialer type" && phoneDetails.type === "") {
      // errorMessage.type = "please select the Dialer Type";
      // isValid = false;
    }

    // Set errors after validation
    setErrors(errorMessage);

    return isValid;
  };

  // const handleKeyPress = (event) => {
  //   // If the pressed key is not a number or a control key (e.g., backspace)
  //   if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
  //     event.preventDefault(); // Prevent the default action (typing)
  //   }
  // };

  const handleKeyPress = (event) => {
    const phoneNumber = event.target.value;
    // If the pressed key is not a number, "+" or a control key (e.g., backspace)
    if (
      !/[0-9+]/.test(event.key) && // Allow digits or +
      event.key !== "Backspace" // Allow backspace
    ) {
      event.preventDefault(); // Prevent the default action (typing)
    }

    // Handle the special case for "+" at the beginning
    if (event.key === "+" && phoneNumber.includes("+")) {
      event.preventDefault(); // Prevent adding more than one "+"
    }

    // Limit the length of the phone number to 11 characters (1 for "+" and 10 digits)
    if (phoneNumber.length >= 12 && event.key !== "Backspace") {
      event.preventDefault(); // Prevent typing beyond 11 characters
    }
  };

  const handleChange = (e) => {
    console.log("dreirueire", e.target.name, e.target.value);
    const name = e.target.name;
    const value = e.target.value;
    setPhoneDetails({ ...phoneDetails, [name]: value });
  };

  const handleClose = () => {
    handlePopClose();
    setPhoneDetails({
      name: "",
      phoneNumber: "",
      sID: "",
      authToken: "",
      type: "twilio",
    });
    setErrors({});
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!phoneDetails.type) {
      formErrors.type = "please select the Dialer Type";
      isValid = false;
    }
    if (!phoneDetails.name) {
      formErrors.name = "Name is required";
      isValid = false;
    } else if (phoneDetails.name?.length < 5) {
      formErrors.name = "  Name must be 5 characters";
      isValid = false;
    }
    if (!phoneDetails.phoneNumber) {
      formErrors.phoneNumber = "Phone Number is required";
      isValid = false;
    }
    if (!phoneDetails.sID) {
      formErrors.sID = "Account SID is required";
      isValid = false;
    }
    if (!phoneDetails.authToken) {
      formErrors.authToken = "Auth Token is required";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await createPhoneNumber(phoneDetails);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        handlePopClose();
        setPhoneDetails({
          name: "",
          phoneNumber: "",
          sID: "",
          authToken: "",
          type: "twilio",
        });
        getAllPhoneNumber();
        setErrors({});
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await updatePhoneNumber(phoneDetails);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        handlePopClose();
        setPhoneDetails({
          name: "",
          phoneNumber: "",
          sID: "",
          authToken: "",
          type: "twilio",
        });
        getAllPhoneNumber();
        setErrors({});
        setLoad(false);
        setEditOpen(false);
        setPop(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };
  // delete
  const [authdelete, setAuthdelete] = React.useState(true);
  const [anchorEldelete, setAnchorEldelete] = React.useState(null);
  const [numberId, setNumberId] = useState(null);
  const handleChangedelete = (event) => {
    setAuthdelete(event.target.checked);
  };

  const handleMenudelete = (event, numberId) => {
    setNumberId(numberId);
    setAnchorEldelete(event.currentTarget);
  };

  const handleClosedelete = () => {
    setAnchorEldelete(null);
  };

  const displayedRows = phoneNumberList?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleDelete = async () => {
    const data = {
      numberId: numberId,
    };
    setLoad(true);
    const response = await deletePhoneNumber(data);
    if (response?.data?.success === true) {
      toast.success(response.data.message);
      handleClosedelete();
      getAllPhoneNumber();
      setLoad(false);
    } else {
      toast.error(response?.data?.message);
      setLoad(false);

      // setPop(false)
    }
  };

  if (isLoading) return <Loader />;

  return (
    <div className="PhoneNumber">
      <ToastContainer autoClose={2000} />
      {/* {userResponse.haveNumber===true && <Loader/>} */}
      {/* {isLoading===true &&  <Loader/>} */}

      {displayedRows?.length > 0 ? (
        <div>
          <div className="display-2 heading-line">
            <h3>Dialer (TWILIO)</h3>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center" }}
            >
              <div className="bg-clr mt-10">
                <Button startIcon={<AddIcon />} onClick={handlePopOpen}>
                  Add Phone Number
                </Button>
              </div>
              <div className="theme-borde-clr mt-10">
                <a href="https://www.twilio.com/en-us" target="_blank">
                  <Button>Go To Twilio</Button>
                </a>
              </div>
            </Stack>
          </div>
          <Grid2
            container
            spacing={1}
            sx={{ alignItems: "center", marginTop: "20px" }}
          >
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mb-20"
            >
              <div className="ContactListTable-main mt-20">
                <TableContainer
                  component={Paper}
                  sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                >
                  <Table
                    sx={{ minWidth: 700 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">SI.No</StyledTableCell>
                        <StyledTableCell align="center">Name</StyledTableCell>

                        <StyledTableCell align="center">
                          Phone Number{" "}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Auth Token
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Account SID
                        </StyledTableCell>
                        <StyledTableCell align="center">Action</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayedRows?.length > 0 &&
                        displayedRows?.map((row, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell component="th" align="center">
                              <Link>
                                <h4>{index + 1} </h4>{" "}
                              </Link>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <h4>{row.name}</h4>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <h4>{row.phoneNumber} </h4>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <h4>{row.authToken}</h4>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <h4>{row.sid}</h4>
                            </StyledTableCell>{" "}
                            <StyledTableCell align="center">
                              <Stack
                                direction="row"
                                spacing={2}
                                sx={{ justifyContent: "center" }}
                              >
                                <CreateOutlinedIcon
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleEditPopOpen(row);
                                    setEditOpen(true);
                                  }}
                                />
                                <DeleteOutlineOutlinedIcon
                                  sx={{ cursor: "pointer" }}
                                  onClick={(e) =>
                                    handleMenudelete(e, row?.numberId)
                                  }
                                />
                              </Stack>
                            </StyledTableCell>{" "}
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEldelete}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorEldelete)}
                    onClose={handleClosedelete}
                  >
                    <div className="Delete-button-popup ">
                      <div className="display-11">
                        <Typography
                          color="inherit"
                          sx={{
                            fontSize: "12px",
                            textAlign: "start",
                            paddingBottom: "10px",
                          }}
                        >
                          <b style={{ display: "flex", gap: "5px" }}>
                            {" "}
                            <span className="red">
                              <ErrorOutlineIcon />
                            </span>{" "}
                            Delete this item
                          </b>
                          Are you sure to delete this item?
                        </Typography>
                      </div>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ justifyContent: "center" }}
                        className="assitant-stack"
                      >
                        <div className="border-graient Delete-button mt-10">
                          <Button onClick={() => handleClosedelete()}>
                            NO
                          </Button>
                        </div>
                        <div className="border-graient gradient-bg Delete-button mt-10">
                          <Button onClick={handleDelete}>Yes</Button>
                        </div>
                      </Stack>
                    </div>
                  </Menu>
                </TableContainer>
                <div className="Pagination-main">
                  {/* <TablePagination
                      rowsPerPageOptions={[3, 25, 100]}
                      component="div"
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                  {phoneNumberList?.length > 5 && (
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={phoneNumberList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  )}
                </div>
              </div>
            </Grid2>
            <div className="modal-popup">
              <Modal
                open={pop}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box className="common-modal-box phn-modal">
                  <div className="close-icons-popup1" align="right">
                    <HighlightOffIcon onClick={handleClose} />
                  </div>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {editOpen === true
                      ? "Edit Phone Number"
                      : "Create Phone Number"}
                  </Typography>
                  <div className="assistant-cnt mt-20">
                    <div className="input-common">
                      <div className="display-1">
                        <label>Dialer Type *</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Select the dialer type that best suits your
                                preferences and communication requirements.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <FormControl fullWidth>
                        <Select
                          id="dialer type"
                          displayEmpty
                          value={phoneDetails.type}
                          // onChange={handleChangeVoice1}
                          input={<OutlinedInput />}
                          MenuProps={MenuPropsVoice1}
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem
                            value="twilio"
                            onClick={(e) =>
                              setPhoneDetails({
                                ...phoneDetails,
                                type: "twilio",
                              })
                            }
                          >
                            Twillo
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="input-common mt-20">
                      <div className="display-1">
                        <label>Phone Number *</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter your dialer registered phone number for
                                calling. This is the number your contacts would
                                receive call from. Note: Please ensure voice
                                calling facility is enabled on this number for
                                your contact's region.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <TextField
                        fullWidth
                        id="fullWidth"
                        placeholder="Enter Phone Number"
                        name="phoneNumber"
                        value={phoneDetails.phoneNumber}
                        onFocus={(e) => validateFocus(e)}
                        onInput={validateFocus}
                        error={!!errors.phoneNumber}
                        helperText={errors.phoneNumber}
                        onChange={(e) => handleChange(e)}
                        onKeyPress={handleKeyPress}
                        inputProps={{
                          maxLength: 12,
                        }}
                        type="tel"
                      />
                    </div>

                    <div className="input-common mt-20">
                      <div className="display-1">
                        <label>Account SID *</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter your account ID provided by your dialer
                                account.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={phoneDetails.sID}
                          placeholder="Enter Dialer Auth ID"
                          // onChange={(e) => {
                          //   setPassword(e.target.value);
                          // }}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.sID}
                          name="sID"
                          inputProps={{ maxLength: 45 }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                className="eye-icon"
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <FormHelperText
                          sx={{
                            margin: "0px 5px",
                            fontSize: "10px",
                            color: "#AFAFAF",
                          }}
                        >
                          Your AuthId will be encrypted at our end. Nobody will
                          be able to see your AuthId.
                        </FormHelperText>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                            // fontWeight: "bold",
                          }}
                        >
                          {errors.sID}
                        </span>{" "}
                      </FormControl>
                    </div>

                    <div className="input-common mt-20">
                      <div className="display-1">
                        <label>Auth Token *</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter your account auth token provided by your
                                dialer account..
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={authToken ? "text" : "password"}
                          value={phoneDetails.authToken}
                          placeholder="Enter Dialer Auth token"
                          // onChange={(e) => {
                          //   setPassword(e.target.value);
                          // }}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          error={!!errors.authToken}
                          name="authToken"
                          inputProps={{ maxLength: 45 }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                className="eye-icon"
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickToken}
                                edge="end"
                              >
                                {authToken ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <FormHelperText
                          sx={{
                            margin: "0px 5px",
                            fontSize: "10px",
                            color: "#AFAFAF",
                          }}
                        >
                          Your Auth Token will be encrypted at our end. Nobody
                          will be able to see your token.
                        </FormHelperText>
                        <FormHelperText className="Mui-error">
                          {errors.authToken}
                        </FormHelperText>
                        {/* {errors?.authToken !== "" && (
                         <p
                           className={
                             errors.authToken != "" ? "Mui-error" : ""
                           }
                         >
                           {errors?.authToken}
                         </p>
                       )} */}
                      </FormControl>
                    </div>
                    <div className="input-common mt-20">
                      <div className="display-1">
                        <label>Name *</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter a name for this number for easy
                                identification..
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <TextField
                        fullWidth
                        id="fullWidth"
                        rows={4}
                        placeholder="Enter a name for this number"
                        name="name"
                        value={phoneDetails.name}
                        onFocus={(e) => validateFocus(e)}
                        onInput={validateFocus}
                        error={!!errors.name}
                        helperText={errors.name}
                        onChange={(e) => handleChange(e)}
                        type="text"
                        inputProps={{ inputMode: "text" }}
                      />
                    </div>
                  </div>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "center" }}
                    className="mt-20"
                  >
                    <div className="border-graient mt-10">
                      <Button
                        onClick={() => {
                          handleClose();
                          setErrors({});
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div className="border-graient gradient-bg mt-10">
                      {/* <Button
                          // onClick={() => {
                          //   navigate("/createassistant");
                          // }}
                          onClick={handleSubmit}
                        >
                          Save
                        </Button> */}
                      {load ? (
                        <Button fullWidth>Processing...</Button>
                      ) : editOpen === true ? (
                        <Button
                          type="submit"
                          fullWidth
                          onClick={handleEditSubmit}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button type="submit" fullWidth onClick={handleSubmit}>
                          Save
                        </Button>
                      )}
                    </div>
                  </Stack>
                </Box>
              </Modal>
            </div>
          </Grid2>
        </div>
      ) : (
        //   </Box>
        // </Box>
        // <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        //   <SideBar />

        //   <Box
        //     component="main"
        //     sx={{
        //       flexGrow: 1,
        //       p: isLgUp ? 5 : 1,
        //       width: { sm: `calc(100% - ${drawerWidth}px)` },
        //       marginTop: isLgUp ? "50px" : "80px",
        //     }}
        //   >
        <Grid2 container spacing={2}>
          <Grid2
            item
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            className="mb-20"
          >
            <div className="PhoneNumber-main">
              <div className="display-2 heading-line">
                <h3>Dialer (TWILIO)</h3>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ justifyContent: "center" }}
                >
                  <div className="bg-clr mt-10">
                    <Button startIcon={<AddIcon />} onClick={handlePopOpen}>
                      Add Phone Number
                    </Button>
                  </div>
                  <div className="theme-borde-clr mt-10">
                    <a href="https://www.twilio.com/en-us" target="_blank">
                      <Button>Go To Twilio</Button>
                    </a>
                  </div>
                </Stack>
              </div>
              <Grid2 container spacing={2}>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 7 }}
                  className="mb-20 mt-30"
                >
                  <div className="phone-number-steps">
                    <h2>Follow these steps to buy your Twilio Phone Number</h2>
                    <div className="display-1 phone-number-steps-color">
                      <h3>1</h3>{" "}
                      <p>
                        Click on 'Go To Twilio' button. Sign up your Twilio
                        account.
                      </p>
                    </div>
                    <div className="display-1 phone-number-steps-color">
                      <h3>2</h3> <p>Go to "Phone Numbers" in the left panel.</p>
                    </div>
                    <div className="display-1 phone-number-steps-color">
                      <h3>3</h3> <p>Select "Manage" then "Buy a Number".</p>
                    </div>
                    <div className="display-1 phone-number-steps-color">
                      <h3>4</h3>{" "}
                      <p>
                        Choose any number of your choice and click on "Buy". Now
                        Agree with the T&C and click on Buy.
                      </p>
                    </div>
                    <div className="display-1 phone-number-steps-color">
                      <h3>5</h3>{" "}
                      <p>
                        Click on your account name (top left), then scroll down
                        to view your Account SID and Auth Token
                      </p>
                    </div>
                    <div className="display-1 phone-number-steps-color">
                      <h3>6</h3>{" "}
                      <p>
                        To add this number to VoiceBot, click on "Add Phone
                        Number" button above & enter the details and Click on
                        "Save".
                      </p>
                    </div>
                  </div>
                </Grid2>
              </Grid2>

              <div className="modal-popup">
                <Modal
                  open={pop}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box phn-modal">
                    <div className="close-icons-popup1" align="right">
                      <HighlightOffIcon onClick={handleClose} />
                    </div>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Create Phone Number
                    </Typography>
                    <div className="assistant-cnt mt-20">
                      <div className="input-common">
                        <div className="display-1">
                          <label>Dialer Type</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Select the dialer type that best suits your
                                  preferences and communication requirements.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl fullWidth>
                          <Select
                            id="dialer type"
                            displayEmpty
                            value={phoneDetails.type}
                            // onChange={handleChangeVoice1}
                            input={<OutlinedInput />}
                            MenuProps={MenuPropsVoice1}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem
                              value="twilio"
                              onClick={(e) =>
                                setPhoneDetails({
                                  ...phoneDetails,
                                  type: "twilio",
                                })
                              }
                            >
                              Twillo
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Phone Number *</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Enter your dialer registered phone number for
                                  calling. This is the number your contacts
                                  would receive call from. Note: Please ensure
                                  voice calling facility is enabled on this
                                  number for your contact's region.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          placeholder="Enter Phone Number"
                          name="phoneNumber"
                          value={phoneDetails.phoneNumber}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.phoneNumber}
                          helperText={errors.phoneNumber}
                          onChange={(e) => handleChange(e)}
                          onKeyPress={handleKeyPress}
                          inputProps={{
                            maxLength: 12,
                          }}
                          type="number"
                        />
                      </div>

                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Account SID *</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Enter your account ID provided by your dialer
                                  account.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? "text" : "password"}
                            value={phoneDetails.sID}
                            placeholder="Enter Dialer Auth ID"
                            // onChange={(e) => {
                            //   setPassword(e.target.value);
                            // }}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            error={!!errors.sID}
                            name="sID"
                            inputProps={{ maxLength: 45 }}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                          <FormHelperText
                            sx={{
                              margin: "0px 5px",
                              fontSize: "10px",
                              color: "#AFAFAF",
                            }}
                          >
                            Your AuthId will be encrypted at our end. Nobody
                            will be able to see your AuthId.
                          </FormHelperText>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                              // fontWeight: "bold",
                            }}
                          >
                            {errors.sID}
                          </span>{" "}
                        </FormControl>
                      </div>

                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Auth Token *</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Enter your account auth token provided by your
                                  dialer account..
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={authToken ? "text" : "password"}
                            value={phoneDetails.authToken}
                            placeholder="Enter Dialer Auth token"
                            // onChange={(e) => {
                            //   setPassword(e.target.value);
                            // }}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            error={!!errors.authToken}
                            name="authToken"
                            inputProps={{ maxLength: 45 }}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickToken}
                                  edge="end"
                                >
                                  {authToken ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                          <FormHelperText
                            sx={{
                              margin: "0px 5px",
                              fontSize: "10px",
                              color: "#AFAFAF",
                            }}
                          >
                            Your Auth Token will be encrypted at our end. Nobody
                            will be able to see your token.
                          </FormHelperText>
                          <FormHelperText className="Mui-error">
                            {errors.authToken}
                          </FormHelperText>
                          {/* {errors?.authToken !== "" && (
                         <p
                           className={
                             errors.authToken != "" ? "Mui-error" : ""
                           }
                         >
                           {errors?.authToken}
                         </p>
                       )} */}
                        </FormControl>
                      </div>
                      <div className="input-common mt-20">
                        <div className="display-1">
                          <label>Name *</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Enter a name for this number for easy
                                  identification.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter a name for this number"
                          name="name"
                          value={phoneDetails.name}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.name}
                          helperText={errors.name}
                          onChange={(e) => handleChange(e)}
                          type="text"
                          inputProps={{ inputMode: "text" }}
                        />
                      </div>
                    </div>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ justifyContent: "center" }}
                      className="mt-20"
                    >
                      <div className="border-graient mt-10">
                        <Button
                          onClick={() => {
                            handleClose();
                            setErrors({});
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                      <div className="border-graient gradient-bg mt-10">
                        {/* <Button
                              // onClick={() => {
                              //   navigate("/createassistant");
                              // }}
                              onClick={handleSubmit}
                            >
                              Save
                            </Button> */}
                        {load ? (
                          <Button fullWidth>Processing...</Button>
                        ) : (
                          <Button
                            type="submit"
                            fullWidth
                            onClick={handleSubmit}
                            // onClick={() => {
                            //   navigate("/");
                            // }}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </Stack>
                  </Box>
                </Modal>
              </div>
            </div>
          </Grid2>
        </Grid2>
        //   </Box>
        // </Box>
      )}
    </div>
  );
};

export default PhoneNumber;
